export const ACTIVITY_TYPES = {
  STATUS: 'status',
  CHANGE: 'change',
};

export const ACTIVITY_DOMAIN_OBJECTS = {
  DOSSIER: 'Dossier',
  CLARIFICATION: 'Request clarification',
  CASE_TABLE: 'Case table',
  PROCEDURE: 'Project',
  PROCEDURE_GOAL: 'Project goal',
};

export const ACTIVITY_ACTIONS = {
  CREATE: 'create',
  UPDATE: 'update'
};
